/* eslint-disable filenames/match-exported */
import { forwardRef } from 'react';
import InputLabelInside, { InputLabelInsideProps } from './InputLabelInside';
import PasswordInput, { PasswordInputProps } from './PasswordInput';
import SearchInput, { SearchInputProps } from './SearchInput';
import TextInput, { TextInputProps } from './TextInput';

type InputRef = HTMLInputElement;
type InputProps =
  | ({ variation: 'base' } & TextInputProps)
  | ({ variation: 'search' } & SearchInputProps)
  | ({ variation: 'password' } & PasswordInputProps)
  | ({ variation: 'label-inside' } & InputLabelInsideProps);

const Input = forwardRef<InputRef, InputProps>((props, ref) => {
  switch (props.variation) {
    case 'search':
      return <SearchInput ref={ref} {...props} />;
    case 'password':
      return <PasswordInput ref={ref} {...props} />;
    case 'label-inside':
      return <InputLabelInside ref={ref} {...props} />;
    case 'base':
    default:
      return <TextInput ref={ref} {...props} />;
  }
});

export default Input;
